import { render, staticRenderFns } from "./LakalaBalance.vue?vue&type=template&id=0341becd&scoped=true"
import script from "./LakalaBalance.vue?vue&type=script&lang=js"
export * from "./LakalaBalance.vue?vue&type=script&lang=js"
import style0 from "./LakalaBalance.vue?vue&type=style&index=0&id=0341becd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341becd",
  null
  
)

export default component.exports